import React from 'react';
import StaticPage from '../../components/layouts/StaticPage';

function Terms() {
  return (
    <StaticPage>
      <h1>Die Spielregeln</h1>
      <p>Allgemeine Geschäftsbedingungen (AGB) von Triff (www.triff.app)</p>

      <p>Version 4, gültig ab 2. März 2020</p>
      <p>
        Diese Allgemeinen Geschäftsbedingungen (AGB) regeln die Rechte und
        Pflichten in Zusammenhang mit der Nutzung der auf der Webseite
        www.triff.app angebotenen Dienstleistungen.
      </p>

      <h2>Präambel</h2>
      <p>
        Die Webseite www.triff.app wird betrieben von Ganz digital GmbH,
        Bönirainstrasse 16, 8800 Thalwil.
      </p>

      <h2>1. Einleitung</h2>
      <h3>1.1 Anwendungsbereich und Geltung dieser AGB</h3>
      <p>
        Diese AGB von Triff regeln die Nutzung der über die Webseite
        www.triff.app angebotenen Dienstleistungen, die Rechte und Pflichten der
        registrierten Mitglieder (nachfolgend „Mitglieder“) und das vertragliche
        Verhältnis zwischen der Ganz digital GmbH und den Mitgliedern.
      </p>
      <p>
        Das Mitglied bestätigt diese AGB jedes Mal neu, wenn es sich auf
        www.triff.app einloggt. Die Ganz digital GmbH behält sich das Recht vor,
        an diesen AGB jederzeit Änderungen vorzunehmen und die jeweils aktuelle
        Fassung auf www.triff.app zu veröffentlichen. Wesentliche Änderungen
        werden den Mitgliedern zudem innert angemessener Frist vor ihrem
        Inkrafttreten per E-Mail mitgeteilt. Dabei weist die Ganz digital GmbH
        auf die Möglichkeit des Widerspruchs hin. Widerspricht ein Mitglied nach
        dieser Information der Geltung der neuen AGB nicht, gelten die
        geänderten AGB als angenommen.
      </p>

      <h3>1.2 Dienstleistung der Ganz digital GmbH</h3>
      <p>
        Die Ganz digital GmbH stellt die Webseite www.triff.app ihren
        Mitgliedern auf Zusehen hin als Plattform für die Vermittlung von Essen
        zur Verfügung. Der Einfachheit halber bezeichnen die vorliegenden AGB
        den Anbieter von Essen jeweils als „Koch“, den Nachfrager von Essen
        jeweils als „Gast“. Zudem werden in diesen AGB ausschliesslich männliche
        Bezeichnungen verwendet, welche jedoch die weibliche Form stets
        miteinschliessen.
      </p>

      <h3>1.3 Grundsätze für die Nutzung der Webseite www.triff.app</h3>

      <p>
        1.3.1 Eigenverantwortliche Nutzung
        <br />
        <br />
        Auf www.triff.app können die Mitglieder untereinander autonom und
        eigenverantwortlich Verträge abschliessen. Aus solchen Verträgen
        verpflichtet und berechtigt sind einzig der Koch und der Gast. Die
        Erfüllung des Vertrags liegt in der ausschliesslichen Verantwortung des
        Kochs und des Gasts.
      </p>
      <p>
        1.3.2 Rechtsstellung der Ganz digital GmbH
        <br />
        <br />
        Die Ganz digital GmbH ist nicht Vertragspartei von Verträgen, die
        zwischen Mitgliedern bzw. Köchen und Gästen über www.triff.app
        geschlossen werden. Die Ganz digital GmbH, ihre Vertreter, Mitarbeiter
        und Hilfspersonen sind in keiner Weise verantwortlich für die mit der
        Anbahnung und dem Abschluss von Geschäften verbundenen Risiken und
        haften in keiner Weise für etwaige, dadurch entstehende Schäden. Die
        Ganz digital GmbH ist nicht verpflichtet, das Verhalten ihrer Mitglieder
        im Zusammenhang mit der Nutzung der Webseite www.triff.app zu
        kontrollieren. Insbesondere ist die Ganz digital GmbH zwar berechtigt,
        aber nicht verpflichtet, die auf www.triff.app von ihren Mitgliedern
        veröffentlichten Angebote, Texte und bildlichen Darstellungen auf ihre
        Rechtmässigkeit oder sonstige Zulässigkeit in irgendeiner Weise zu
        überprüfen. Dies gilt insbesondere auch für das von den Mitgliedern in
        Eigenverantwortung genutzte System zur Bewertung von Mitgliedern.
      </p>
      <p>
        1.3.3 Kein Nutzungsanspruch
        <br />
        <br />
        Es besteht kein Anspruch auf Anmeldung, Mitgliedschaft, Nutzung der
        Webseite www.triff.app oder Inanspruchnahme von Dienstleistungen der
        Ganz digital GmbH. Es steht der Ganz digital GmbH insbesondere frei,
        jederzeit eine Anmeldung abzulehnen, oder nach Massgabe von Ziff. 2.4
        ein Mitglied auszuschliessen, eine Nutzung zu verbieten oder eine
        Dienstleistung einzustellen.
      </p>

      <h3>1.4 Definitionen</h3>
      <p>
        1.4.1 Mitglied
        <br />
        <br />
        Mit der Registrierung, d.h. mit der Angabe seiner abgefragten
        persönlichen Angaben und seiner Zustimmung zu den vorliegenden AGB wird
        der Interessent zu einem Mitglied von www.triff.app. Die Ganz digital
        GmbH kann zusätzliche Angaben und/oder Verifikationen vorsehen oder
        darauf verzichten. Registrierung und Mitgliedschaft sind kostenlos.
      </p>
      <p>
        1.4.2 Angebot
        <br />
        <br />
        Angebot bedeutet die Veröffentlichung eines eigenverantwortlich
        ausgestalteten Essensangebots auf www.triff.app.
        <br />
        Das Einstellen eines Essensangebots unter Angabe eines sogenannten
        Fixpreises durch den Koch stellt eine Einladung zur Offerte dar an
        denjenigen Gast, der sich bereit erklärt, diesen festgelegten Betrag zu
        bezahlen.
        <br />
        Für das Einstellen von Essensangeboten auf www.triff.app kann die Ganz
        digital GmbH eine Service-Gebühr erheben.
      </p>

      <h2>2. Mitgliedschaft</h2>
      <h3>2.1 Zweck</h3>
      <p>
        Voraussetzung für das Anbieten und den Kauf von Essen auf www.triff.app,
        für die Benutzung von damit zusammenhängenden Webseitenfunktionen sowie
        für die Benutzung passwortgeschützter Bereiche auf www.triff.app
        (insbesondere eines persönlichen Kontos) ist die Mitgliedschaft als
        registrierter Benutzer.
      </p>

      <h3>2.2 Beschreibung</h3>
      <p>
        Die Mitgliedschaft ist persönlich und nicht übertragbar. Es ist jedoch
        registrierten Mitgliedern erlaubt, zu einem Essen weitere Gäste
        anzumelden und mitzubringen oder Kinder zu Essen zu schicken. Ein
        Vertrag besteht stets zwischen registrierten Mitgliedern. Verantwortlich
        und verpflichtet, auch zur Zahlung des Fixpreises und der Provision
        gemäss Ziffer 5.4, ist jedoch in jedem Fall das Mitglied, welches die
        Buchung vorgenommen hat.
      </p>

      <h3>2.3 Mindestvoraussetzungen für die Mitgliedschaft</h3>
      <p>
        2.3.1 Handlungsfähigkeit
        <br />
        <br />
        Die Mitgliedschaft steht nur unbeschränkt handlungsfähigen, natürlichen
        oder juristischen Personen offen. Von der Mitgliedschaft ausgeschlossen
        sind minderjährige Personen (Personen unter 18 Jahren).
      </p>
      <p>
        2.3.2 Persönliche Angaben
        <br />
        <br />
        Die bei der Registrierung einzugebenden Angaben müssen jederzeit
        vollständig und korrekt sein und enthalten grundsätzlich zwingend
        folgendes: vollständiger Vor- und Nachname, Adresse des aktuellen
        Hauptwohnsitzes, gültige E-Mail-Adresse, ein Foto und eine persönliche
        Beschreibung. Bei der Anmeldung eines Unternehmens bzw. eines
        gewerblichen Mitgliederkontos sind der Name der Kontaktperson und
        überdies die vollständige Firma anzugeben. Bei Änderungen ist das
        Mitglied verpflichtet, diese umgehend im persönlichen Benutzerkonto auf
        www.triff.app nachzuführen, so dass die Angaben jederzeit vollständig
        und korrekt sind.
        <br />
        Ganz digital GmbH kann jederzeit für spezifische Funktionen zusätzliche
        Angaben und/oder Verifikationen vorsehen oder darauf verzichten.
      </p>
      <p>
        2.3.3 Personen mit Sitz im Ausland
        <br />
        <br />
        Personen mit Wohnsitz/Sitz im Ausland können sich auf www.triff.app als
        Mitglied registrieren, dürfen die Website jedoch nur als Gast nutzen.
      </p>

      <h3>2.4 Beginn und Beendigung der Mitgliedschaft</h3>
      <p>
        2.4.1 Beginn
        <br />
        <br />
        Die Mitgliedschaft beginnt nach erfolgter Registrierung und Zustimmung
        zu diesen AGB und nach einer entsprechenden Bestätigung durch die Ganz
        digital GmbH, angezeigt auf dem Bildschirm oder per E-Mail.
      </p>
      <p>
        2.4.2 Beendigung durch das Mitglied
        <br />
        <br />
        Die Beendigung der Mitgliedschaft ist, sofern alle nachfolgenden
        Bedingungen erfüllt sind, jederzeit durch Anklicken des
        Kündigungs-Buttons auf www.triff.app möglich.
        <br />
        Die Ganz digital GmbH bestätigt mit einer E-Mail die Kündigung und
        blockiert das entsprechende Konto. Allfällige abgegebene und erhaltene
        Bewertungen sowie „Fragen & Antworten“ eines Mitglieds erscheinen auch
        nach dessen Kündigung der Mitgliedschaft weiterhin auf www.triff.app.
      </p>
      <p>
        2.4.3 Beendigung durch die Ganz digital GmbH
        <br />
        <br />
        Die Ganz digital GmbH ist berechtigt, ein Mitglied, insbesondere bei
        Missachtung der AGB, jederzeit auszuschliessen (d.h. die Mitgliedschaft
        zu kündigen), eine Nutzung zu verbieten oder eine Dienstleistung
        einzustellen, ohne dass dem betreffenden Mitglied hieraus Ansprüche
        gegenüber der Ganz digital GmbH erwachsen. Die Ganz digital GmbH ist
        berechtigt, ein Mitglied vorübergehend zu sperren oder definitiv
        auszuschliessen, wenn es wahrscheinlich erscheint, dass ein anderes
        bereits gesperrtes oder ausgeschlossenes Mitglied (wie z.B.
        Familienangehörige oder Hausgenossen) über dieses Konto Geschäfte
        abwickelt, oder wenn ein begründeter Verdacht besteht, dass das Mitglied
        Rechte Dritter verletzt hat.
        <br />
        Bereits angefallene Gebühren, Mahnspesen und Umtriebsentschädigungen
        sind auch bei einem Ausschluss weiterhin geschuldet.
        <br />
        Allfällige abgegebene und erhaltene Bewertungen sowie „Fragen &
        Antworten“ eines Mitglieds erscheinen auch nach der Beendigung der
        Mitgliedschaft weiterhin auf www.triff.app
        <br />
        Ausgeschlossene Mitglieder haben kein Recht, sich ohne vorgängig
        eingeholtes Einverständnis von Ganz digital GmbH wieder als Mitglied
        anzumelden, sei es unter eigenem, sei es unter fremdem Namen.
        Widerhandlungen gegen diese Bestimmung werden mit CHF 1’000.– in
        Rechnung gestellt.
      </p>
      <p>
        2.4.4 Folgen der Beendigung der Mitgliedschaft
        <br />
        <br />
        Nach der Löschung der Mitgliedschaft wird das entsprechende Nutzer-Konto
        saldiert und werden allfällige Fehlbeträge der hinterlegten Kreditkarte
        belastet oder allfällige Guthaben gutgeschrieben. Die Beendigung der
        Mitgliedschaft entbindet das Mitglied nicht von der Erfüllung von bis zu
        diesem Zeitpunkt eingegangenen Verpflichtungen gegenüber anderen
        Mitgliedern.
      </p>

      <h2>3. Mitgliederpflichten allgemein</h2>
      <h3>3.1 Geheimhaltung der Zugangsdaten</h3>
      <p>
        Es steht in der Verantwortung jedes einzelnen Mitgliedes, die ihm von
        Ganz digital GmbH im Rahmen seiner Anmeldung mitgeteilten oder selbst
        erstellten Zugangsdaten (Passwort) geheim zu halten.
      </p>

      <h3>3.2 Technische Eingriffe</h3>
      <p>
        Die Verwendung von Mechanismen, Software oder sonstiger Scripts, die den
        ordnungsgemässen Betrieb der Webseite stören könnten, ist untersagt.
        <br />
        Mitglieder dürfen keine Massnahmen ergreifen, die eine unzumutbare oder
        übermässige Belastung der Infrastruktur der Ganz digital GmbH zur Folge
        haben könnten.
        <br />
        Es ist Mitgliedern untersagt, von der Ganz digital GmbH generierte
        Inhalte zu blockieren, zu überschreiben oder zu modifizieren oder in
        sonstiger Weise störend in die Webseite www.triff.app der Ganz digital
        GmbH einzugreifen.
      </p>

      <h3>3.3 Immaterialgüterrechte Dritter (Geistiges Eigentum)</h3>
      <p>
        Angebote, Texte und bildliche Darstellungen, welche ein Mitglied auf
        www.triff.app in irgendeiner Art und Form (Angebotsbeschreibungen,
        Bewertungen, Einträge im Rahmen der „Fragen und Antworten-Funktion“,
        etc.) veröffentlicht oder auf sonstige Weise über www.triff.app
        kommuniziert, dürfen keinerlei Immaterialgüterrechte Dritter verletzen.
        Das Mitglied darf auf www.triff.app einzig Bilder und Texte verwenden
        und publizieren, welche es selber erstellt hat oder deren Verwendung der
        Rechteinhaber zugestimmt hat; dies gilt insbesondere auch für Text- und
        Bildmaterial, welches auf einer anderen Webseite öffentlich zugänglich
        ist.
      </p>

      <h3>3.4 Persönlichkeitsrechte Dritter</h3>
      <p>
        Angebote, Texte und bildliche Darstellungen, welche ein Mitglied auf
        www.triff.app in irgendeiner Art und Form (Angebotsbeschreibungen,
        Bewertungen, Einträge im Rahmen der „Fragen und Antworten-Funktion“,
        etc.) veröffentlicht oder auf sonstige Weise über www.triff.app
        kommuniziert, dürfen keinerlei Persönlichkeitsrechte Dritter verletzen;
        insbesondere dürfen sie nicht beleidigend, obszön, diffamierend,
        belästigend, ehrverletzend, verunglimpfend, herabsetzend, rufschädigend
        u.ä. sein.
      </p>

      <h3>3.5 Werbung</h3>
      <p>
        Angebote, Texte und bildliche Darstellungen, welche ein Mitglied auf
        www.triff.app in irgendeiner Art und Form (Angebotsbeschreibungen,
        Bewertungen, Einträge im Rahmen der „Fragen und
        Antworten-Funktion“,etc.) veröffentlicht oder auf sonstige Weise über
        www.triff.app kommuniziert, dürfen keine Form von Werbung enthalten.
        <br />
        Die Ganz digital GmbH darf von Mitgliedern auf www.triff.app
        eingestellte Inhalte für Werbung zu eigenen Zwecken verwenden.
      </p>

      <h3>3.6 Links, (Web-)Adressen, E-Mail-Adressen und Telefonnummern</h3>
      <p>
        Die auf www.triff.app veröffentlichten Angebote und Inhalte (inkl.
        Bilder) dürfen keinerlei URL-Links, (Web-)Adressen, E-Mail-Adressen oder
        Telefonnummern enthalten.
      </p>

      <h3>3.7 Nutzung von Inhalten</h3>
      <p>
        Die in einem Angebot einsehbaren Informationen über einen Koch oder
        sonstige Informationen, welche die Ganz digital GmbH allenfalls im
        Zusammenhang mit Angeboten übermittelt, dürfen von Mitgliedern nur im
        Zusammenhang mit dem entsprechenden Angebot benutzt werden; insbesondere
        ist eine Verwendung zu Werbezwecken untersagt. Es ist zudem nicht
        gestattet, diese Informationen für den Versand von Newslettern zu
        verwenden oder an Dritte weiterzugeben.
      </p>

      <h3>3.8 Kein Vertragsschluss ausserhalb von www.triff.app</h3>
      <p>
        Texte und bildliche Darstellungen, welche ein Mitglied auf www.triff.app
        in irgendeiner Art und Form veröffentlicht, dürfen nicht auf
        Vertragsabschlüsse ausserhalb von www.triff.app abzielen oder dazu
        direkt oder indirekt auffordern.
      </p>

      <h3>3.9 Wahrheitsgemässe Benutzung des Bewertungssystems</h3>
      <p>
        Der Benutzer ist verpflichtet, in den von ihm abgegebenen Bewertungen
        wahrheitsgemässe Angaben zu machen. Die Bewertungen müssen sachlich sein
        und dürfen keine persönlichen Beleidigungen enthalten. Es ist nicht
        erlaubt, in einer Bewertung Werbung einfliessen zu lassen (z.B. Angabe
        einer www-Adresse, etc.). Jede unlautere Einflussnahme auf das eigene
        oder auf fremde Bewertungsprofile oder Bewertungen sowie jeder
        Missbrauch des Bewertungssystems sind untersagt. Es ist zudem nicht
        erlaubt, in einer Bewertung persönliche Benutzerangaben zu nennen. Es
        ist ebenfalls nicht gestattet, irreführende Bewertungen abzugeben oder
        das Bewertungssystem zum eigenen Vorteil zu manipulieren. Die Ganz
        digital GmbH ist jederzeit und ohne Rückfrage berechtigt, aber nicht
        verpflichtet, ausnahmsweise ins autonome Bewertungssystem einzugreifen
        und Bewertungen zu löschen und/oder zu berichtigen.
      </p>

      <h3>3.10 Verbot der Umgehung der Gebührenstruktur</h3>
      <p>
        Es ist verboten, Handlungen vorzunehmen die dazu dienen, die
        Gebührenstruktur von Ganz digital GmbH zu umgehen.
      </p>

      <h2>4. Betrieb auf www.triff.app</h2>
      <h3>4.1 Unzulässige Angebote</h3>
      <p>
        Die Ganz digital GmbH ist befugt, das Anbieten bestimmter Essen auf
        www.triff.app jederzeit nach eigenem Ermessen und ohne Angabe von
        Gründen zu verbieten.
        <br />
        Jedes Essensangebot muss ein alkoholfreies Getränk beinhalten,
        mindestens Wasser in beliebiger Menge.
      </p>

      <h3>4.2 Veröffentlichte Inhalte</h3>
      <p>
        Die Ganz digital GmbH ist befugt, jederzeit einzelne Angebote, Gebote
        sowie Text- und Bildmaterial auf der Webseite ohne Rückfrage und ohne
        Angabe von Gründen zu löschen. Dies gilt insbesondere auch für
        offensichtlich nicht ernst gemeinte Gebote und Text- oder Bildmaterial,
        das die Rechte Dritter verletzen könnte. Aus entsprechenden Löschungen
        können keinerlei Ansprüche gegen Ganz digital GmbH abgeleitet werden.
      </p>

      <h3>4.3 Verletzungen der AGB durch ein Mitglied</h3>
      <p>
        Die Ganz digital GmbH ist befugt, ein Mitglied zu verwarnen, wenn
        glaubhafte, konkrete Hinweise dafür vorliegen, dass dieses Mitglied die
        vorliegenden AGB verletzt hat. Die Ganz digital GmbH ist insbesondere
        berechtigt, ein Mitglied zu verwarnen, wenn glaubhafte, konkrete
        Hinweise dafür vorliegen, dass das Mitglied mutwillig seine
        Vertragspflichten gegenüber einem anderen Mitglied verletzt hat.
        <br />
        Vorbehalten bleibt das Recht, ein Mitglied von der Mitgliedschaft
        auszuschliessen (siehe Ziffer 2.4).
      </p>

      <h2>5. Pflichten des Kochs</h2>
      <h3>5.1 Verfügungsmacht über das Essen</h3>
      <p>Der Koch darf allein Essen anbieten, welches er selbst zubereitet.</p>

      <h3>5.2 Keine Verwendung verbotener oder verdorbener Esswaren</h3>
      <p>
        Es ist dem Koch verboten, verbotene oder verdorbene Esswaren, oder
        Esswaren, welche gegen die guten Sitten verstossen könnten, für die
        Zubereitung von Essen zu verwenden. Die Ganz digital GmbH behält sich
        das jederzeitige Recht vor, Angebote zu löschen und die zuständigen
        Behörden oder verletzte Dritte zu orientieren.
      </p>

      <h3>5.3 Sicherstellen angemessener Hygiene</h3>
      <p>
        Der Koch ist verpflichtet, das Hygienekonzept umzusetzen. Bei
        Zuwiderhandlung behält sich die Ganz digital GmbH das jederzeitige Recht
        vor, fehlbare Köche zu suspendieren und die zuständigen Behörden oder
        verletzte Dritte zu orientieren.
      </p>

      <h3>
        5.4 Wahrheitsgemässe und vollständige Angaben über das angebotene Essen
      </h3>
      <p>
        Der Koch ist verpflichtet, wahrheitsgemässe, nicht irreführende und
        nicht unlautere Angaben über das angebotene Essen zu machen.
      </p>

      <h3>5.5 Essenspreis und Provision</h3>
      <p>
        Die Angebote des Kochs auf www.triff.app stellen Angebote zur
        Offertstellung durch Gäste dar. Der Vertrag zwischen Koch und Gast kommt
        erst dann zustande, wenn der Koch die Buchung eines Gasts bestätigt. Der
        Koch bezeichnet für jedes Essensangebot auf www.triff.app einen
        verbindlichen Fixpreis. Die Provision von Ganz digital GmbH beträgt bei
        Mittagessen 15 Prozent, bei Abendessen und Brunch 20 Prozent auf diesen
        Fixpreis und wird dem Fixpreis zugeschlagen. Bei erfolgter Buchung durch
        den Gast reserviert die Ganz digital GmbH den Fixpreis und die Provision
        auf der Kreditkarte des Gasts. Erst bei erfolgter Bestätigung durch den
        Koch werden Fixpreis und Provision zuzüglich Transaktionskosten
        zugunsten der Ganz digital GmbH per sofort fällig und der Kreditkarte
        des Gastes belastet.
        <br />
        Für den Koch rechnet Ganz digital GmbH die gebuchten und durchgeführten
        Essen mindestens einmal im Monat ab. Für den Gast erfolgt die Abrechnung
        pro gebuchtem und durchgeführtem Essen. Die Abrechnungen werden per
        E-Mail zugestellt.
        <br />
        Der Gast ermächtigt die Ganz digital GmbH, den Fixpreis und die
        Provision seiner bei der Registrierung angegebenen Kreditkarte zu
        belasten, die Provision einzubehalten und den Rest dem entsprechenden
        Koch zu überweisen.
        <br />
        Die Ganz digital GmbH behält sich die Einführung flexibler
        Provisionsmodelle vor.
      </p>

      <h3>5.6 Rückerstattung von Preis und Provision</h3>
      <p>
        Kocht der Koch nicht, erhält der angemeldete Gast den bezahlten Fixpreis
        und die Provison der Ganz digital GmbH zurückerstattet.
        <br />
        Meldet sich der Gast vor Anmeldeschluss des Essens ab, erhält der Gast
        den Fixpreis und die Provision zurückerstattet.
        <br />
        Erscheint der Gast nicht zum Essen oder meldet er sich nach
        Anmeldeschluss ab, verfällt der Fixpreis dem Koch und die Provision der
        Ganz digital GmbH.
        <br />
        Der Gast kann sich auf der Website oder per E-Mail an team@triff.app
        verbindlich von gebuchten Essen abmelden.
      </p>

      <h2>6. Verhältnis Koch – Gast</h2>
      <h3>6.1 Allgemeines</h3>
      <p>
        Die Ganz digital GmbH übernimmt keine Gewähr dafür, dass Mitglieder sich
        bei Buchungen über www.triff.app nach den Grundsätzen von Treu und
        Glauben verhalten. Die Ganz digital GmbH übernimmt insbesondere keine
        Gewähr dafür, dass Mitglieder ihren untereinander allenfalls bestehenden
        Vertragspflichten nachkommen.
      </p>

      <h3>6.2 Angebotsverlauf</h3>
      <p>
        6.2.1 Verbindlichkeit des Angebots
        <br />
        <br />
        Bis zur Bestätigung einer Buchung ist der Koch berechtigt, sein Angebot
        zu löschen und damit zurückzuziehen.
        <br />
        Sobald eine durch ihn bestätigte Buchung vorliegt, ist der Koch an sein
        Angebot gebunden.
      </p>
      <p>
        6.2.2 Form der Buchung
        <br />
        <br />
        Die Buchung durch den Gast kann nur in der dafür vorgesehenen
        Eingabemaske auf der entsprechenden Angebotsseite gültig eingegeben
        werden. Der Koch darf nur Buchungen über die Webseite www.triff.app
        akzeptieren. Buchungen in anderer Form, insbesondere per E-Mail oder per
        Telefon, sind nicht gültig und unbeachtlich.
      </p>
      <p>
        6.2.3 Verbindlichkeit der Buchung
        <br />
        <br />
        Mit der Buchung erklärt der Gast seine Zustimmung zu den vom Koch
        festgelegten Angebot. Der Gast ist an seine Buchung gebunden. Im Übrigen
        wird auf Ziffer 5.5 verwiesen.
      </p>
      <p>
        6.2.4 Vertragsschluss
        <br />
        <br />
        Mit vom Koch bestätigter Buchung kommt ohne weiteres ein verbindlicher
        Vertrag zwischen dem Koch und dem Gast zustande.
      </p>
      <p>
        6.2.5 Vertragsinhalt
        <br />
        <br />
        Der Inhalt des geschlossenen Vertrags bestimmt sich nach der vom Koch
        aufgeführten Essensbeschreibung (inklusive Ergänzungen, die dieser im
        Rahmen der Funktion „Fragen und Antworten“ veröffentlicht hat) und den
        von ihm festgelegten Bedingungen, wie sie im Zeitpunkt der erfolgreichen
        Buchung auf www.triff.app ersichtlich waren, sowie nach etwaigen
        Absprachen zwischen den Parteien vor dem Vertragsschluss.
        <br />
        Der Koch ist verpflichtet, mit dem Gast das Essen grundsätzlich gemäss
        dem Angebot durchzuführen. Leichte Abänderungen und Improvisationen sind
        zulässig.
      </p>
      <p>
        6.2.6 Vertragsabwicklung
        <br />
        <br />
        Beide Vertragsparteien sind verpflichtet, ihren Verpflichtungen aus dem
        Vertrag vollständig und termingerecht nachzukommen.
        <br />
        Die Vertragsabwicklung ist Sache der Parteien; die Erfüllung
        (Abwicklung) des Essens richtet sich nach den jeweiligen
        Vertragsbedingungen.
      </p>
      <p>
        6.2.7 Mängel
        <br />
        <br />
        Sollte ein Essen mit einem in der Angebotsbeschreibung nicht erwähnten
        Mangel behaftet sein, haftet der Koch dem Gast dafür und für allfällige
        Schäden nach den Bestimmungen des schweizerischen Obligationenrechts.
      </p>

      <h2>7. Mobile Endgeräte</h2>
      <p>
        Die Ganz digital GmbH kann ihren Mitgliedern den Zugriff auf Angebote
        und Inhalte auf www.triff.app sowie Buchungen durch mobile Endgeräte
        ermöglichen. Die Ganz digital GmbH behält sich jedoch vor, hiervon
        gewisse Inhalte, Services und Funktionalitäten auszunehmen, welche nur
        auf www.triff.app angezeigt werden.
        <br />
        Die Ganz digital GmbH kann ihren Mitgliedern für den mobilen Zugriff auf
        www.triff.app spezielle Programme (Apps) zur Verfügung stellen, deren
        Nutzung von der Zustimmung zu separaten Nutzungs- oder Lizenzbedingungen
        abhängig ist.
        <br />
        Die Ganz digital GmbH hat das Recht, Angebote und Inhalte von
        Mitgliedern technisch so zu bearbeiten, aufzubereiten und anzupassen,
        dass diese auch auf mobilen Endgeräten dargestellt werden können.
        <br />
        Die Mitglieder sind sich bewusst, dass sich die Darstellung der Angebote
        auf dem mobilen Endgerät von derjenigen auf der Webseite unterscheiden
        kann. Nichtsdestotrotz bleiben die Mitglieder an ihre Gebotsabgabe oder
        einen Vertragsschluss mittels mobilen Endgeräts auf die gleiche Art und
        Weise gebunden, wie wenn sie die Gebotsabgabe oder den Vertragsschluss
        via Webseite vorgenommen hätten.
      </p>

      <h2>8. Datenschutz</h2>
      <p>
        Die Datenschutzerklärung der Ganz digital GmbH ist integraler und
        bindender Teil dieser AGB.
      </p>

      <h2>9. Übertragung von Rechten und Pflichten an Dritte</h2>
      <p>
        Die Ganz digital GmbH behält sich das Recht vor, einzelne oder alle
        Rechte und Pflichten aus diesen AGB an einen Dritten zu übertragen oder
        durch einen Dritten ausüben zu lassen.
        <br />
        Die Mitgliedschaft und sämtliche Rechte und Pflichten des aktuellen oder
        ehemaligen Mitgliedes gegenüber Ganz digital GmbH können durch das
        Mitglied nicht übertragen werden.
      </p>

      <h2>10. Haftungsausschlüsse der Ganz digital GmbH</h2>
      <h3>10.1 Allgemein</h3>
      <p>
        Die Ganz digital GmbH haftet nur für direkte Schäden, die durch eine
        vorsätzliche oder grobfahrlässige eigene Handlung von Ganz digital GmbH
        entstehen. Eine Haftung der Ganz digital GmbH für direkte Schäden bei
        leichtem Verschulden – gleich aus welchem Rechtsgrund – ist unter
        Vorbehalt zwingender gesetzlicher Bestimmungen ausdrücklich
        ausgeschlossen. Eine Haftung der Ganz digital GmbH für indirekte Schäden
        oder für Folgeschäden – gleich aus welchem Rechtsgrund – ist
        vollumfänglich und ausdrücklich ausgeschlossen.
      </p>

      <h3>10.2 Technische Störungen, Wartung</h3>
      <p>
        Die Ganz digital GmbH haftet nur für grobfahrlässig oder vorsätzlich
        verursachte zeitweilige Nichtverfügbarkeit der Webseite, Ausfall
        einzelner oder sämtlicher Webseite-Funktionen oder Fehlfunktionen der
        Webseite www.triff.app. Insbesondere haftet die Ganz digital GmbH bei
        leichter Fahrlässigkeit nicht für technische Probleme, aufgrund derer
        Angebote oder Buchungen nicht, verspätet oder fehlerhaft angenommen oder
        verarbeitet werden. Die Ganz digital GmbH übernimmt insbesondere keine
        Gewähr für die Übereinstimmung der Systemzeituhrzeit mit einer offiziell
        festgelegten Uhrzeit.
        <br />
        Die Webseite www.triff.app der Ganz digital GmbH kann wegen
        Wartungsarbeiten oder anderen Gründen zeitweise nicht oder nur
        beschränkt zur Verfügung stehen, ohne dass dem Nutzer bzw. dem Mitglied
        hieraus Ansprüche gegenüber der Ganz digital GmbH erwachsen.
      </p>

      <h3>10.3 Inhalte und Angebote</h3>
      <p>
        Die Ganz digital GmbH ist nicht zur Prüfung der Angebote, Bewertungen,
        und der sonstigen von den Mitgliedern auf www.triff.app veröffentlichten
        Informationen verpflichtet und übernimmt insbesondere keinerlei
        Verantwortung für:
      </p>
      <ul>
        <li>
          die wahrheitsgemässe und sonst korrekte Ausgestaltung von Angeboten
        </li>
        <li>die Qualität der angebotenen Essen</li>
        <li>
          die Fähigkeit, die Befugnis und den Willen des einzelnen Mitglieds
          hinsichtlich Anbieten, Durchführung, Bezahlung oder sonstiger
          Vertragserfüllung.
        </li>
      </ul>

      <h3>10.4 Mitglieder und Dritte</h3>
      <p>
        Die Ganz digital GmbH haftet insbesondere nicht für Schäden, die
        Mitgliedern oder Dritten durch das Verhalten von anderen Mitgliedern
        oder Dritten im Zusammenhang mit der Nutzung oder dem Missbrauch von
        www.triff.app entstehen.
      </p>

      <h3>10.5 Verlinkte Webseiten</h3>
      <p>
        Die Ganz digital GmbH übernimmt keine Gewähr für die Aktualität,
        Korrektheit, Rechtmässigkeit, Vollständigkeit oder Qualität des Inhalts
        von Webseiten, die über Links auf www.triff.app erreichbar sind und
        schliesst jegliche Haftung in diesem Zusammenhang aus.
      </p>

      <h2>11. Freistellung</h2>
      <p>
        Wenn andere Mitglieder, Nutzer oder Dritte Ansprüche gegen die Ganz
        digital GmbH geltend machen wegen Verletzung ihrer Rechte durch von
        einem Mitglied veröffentlichte Angebote oder Inhalte oder wegen der
        sonstigen Nutzung von www.triff.app durch Mitglieder oder Nutzer, so
        stellt dieses Mitglied bzw. dieser Nutzer Ganz digital GmbH von
        sämtlichen Ansprüchen frei und übernimmt auch die Kosten der
        Rechtsverteidigung von Ganz digital GmbH (inkl. Gerichts- und
        Anwaltskosten).
      </p>

      <h2>12. Salvatorische Klausel</h2>
      <p>
        Sollten einzelne Bestimmungen dieser AGB ganz oder teilweise nichtig
        und/oder unwirksam sein, bleibt die Gültigkeit und/oder Wirksamkeit der
        übrigen Bestimmungen oder Teile solcher Bestimmungen unberührt. Die
        ungültigen und/oder unwirksamen Bestimmungen werden durch solche
        ersetzt, die dem Sinn und Zweck der ungültigen und/oder unwirksamen
        Bestimmungen in rechtwirksamer Weise wirtschaftlich am nächsten kommt.
        Das gleiche gilt bei eventuellen Lücken der Regelung.
      </p>

      <h2>13. Anwendbares Recht und Gerichtsstand</h2>
      <p>
        Alle im Zusammenhang mit den vorliegenden AGB stehenden Streitigkeiten
        zwischen der Ganz digital GmbH und einem (aktuellen oder ehemaligen)
        Mitglied unterstehen schweizerischem Recht.
        <br />
        Gerichtsstand ist, vorbehaltlich anderslautender gesetzlicher
        Bestimmungen, Zürich, Schweiz.
      </p>
      <br />
      <p>Ganz digital GmbH, Thalwil</p>
    </StaticPage>
  );
}

export default Terms;
